/** 账号与角色路由 */
export default{
    name: 'manage',
    path: 'manage',
    meta: { title: '账号与角色' },
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'manage-account',
            path: 'account',
            meta: { title: '平台账号管理' },
            component: ()=>import('@/pages/manage/account.vue')
        },
        {
            name: 'manage-role',
            path: 'role',
            meta: { title: '角色管理' },
            component: ()=>import('@/pages/manage/role.vue')
        }
    ]
}
